/* Vidéos des cartes produit : lecture à l'écran, pause hors écran. */
(() => {
  if (!('IntersectionObserver' in window)) return;

  const SELECTOR = 'video[data-card-video]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting && !reducedMotion.matches) {
        target.play().catch(() => {});
      } else {
        target.pause();
      }
    });
  }, { rootMargin: '100px 0px' });

  const watch = (root) => {
    root.querySelectorAll(`${SELECTOR}:not([data-card-video-watched])`).forEach((video) => {
      video.setAttribute('data-card-video-watched', '');
      observer.observe(video);
    });
  };

  watch(document);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches(SELECTOR) || node.querySelector(SELECTOR))) {
          watch(document);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
